import classnames from 'classnames/bind'
import { useEffect, useState } from 'react'

// Libs
import { MenuType, SkuItemInfoType } from '@/api/fetchProductData'

// Components
import Image from '@/components/common/Image'

// Constants

// Styles
import styles from './style.module.scss'

// Mock Data

const cx = classnames.bind(styles)

interface SpecsProps {
  menu: MenuType[]
  // onChange: (label: string, index: number) => void
  searchKeyList: string[]
  filteredItems: SkuItemInfoType[]
  handleSearchKeyChange?: any
  skuItemInfo: any
  className?: string
  labelClassName?: string
  isFullScreen?: boolean
}

const Specs = ({ menu, filteredItems, searchKeyList, handleSearchKeyChange, skuItemInfo, className, labelClassName, isFullScreen }: SpecsProps) => {
  const [filteredItemsSpecList, setFilteredItemsSpecList] = useState<string[]>([''])
  const [outOfStockList, setOutOfStockList] = useState([''])

  useEffect(() => {
    const lackList = skuItemInfo
      ?.filter((data: any) => data.stockQuantity <= 0 || data.status !== 100)
      .map((item: any) => {
        return { ...item, attrIdString: `${item?.profile.specs.map((item: any) => item.attrId).join('-')}-` } // 仿 api 的 attrDescp
      })

    setOutOfStockList(lackList)
  }, [menu])

  // 判斷同層選項是否保持 disable
  const checkDisable = (option: any, optionIndex: number) => {
    let isDisable = false
    const hasEmptySearchKey = searchKeyList.includes('')

    if (!hasEmptySearchKey) {
      const newSearchKey = [...searchKeyList]
      newSearchKey[optionIndex] = option
      const searchString = newSearchKey.join('-') + '-' // 目前 attr name 的規則是用'-'串起來

      outOfStockList?.forEach((value: any) => {
        if (value.attrIdString?.includes(searchString)) {
          isDisable = true
        }
      })
    } else {
      isDisable = true

      const emptyIndex = searchKeyList.indexOf('')

      const searchStringList = menu[emptyIndex]?.values.map((data) =>
        emptyIndex > optionIndex ? `${option}-${data.attrId}-` : `${data.attrId}-${option}-`,
      )

      searchStringList.forEach((data) => {
        if (outOfStockList?.filter((value: any) => String(value.attrIdString)?.includes(data)).length === 0) {
          isDisable = false
        }
      })
    }

    return isDisable
  }

  useEffect(() => {
    if (filteredItems.length > 0) {
      const newFilteredItemsSpecList = ['']

      const pushUniqueElement = (arr: string[], element: string) => {
        // 本來是用顯示的字串判斷，現在改成 attrId，但 attrId 資料面是數字
        // 如果是數字沒辦法用 includes
        // 目前先在有用 attrId 的地方都轉 string
        if (!arr.includes(element)) {
          arr.push(element)
        }
      }

      filteredItems.forEach((item) => {
        item.profile?.specs.forEach((spec) => pushUniqueElement(newFilteredItemsSpecList, String(spec.attrId)))
      })

      newFilteredItemsSpecList.shift()

      setFilteredItemsSpecList(newFilteredItemsSpecList)
    }
  }, [filteredItems])

  const handleSearch = (label: string, index: number) => {
    const newSearchKey = [...searchKeyList]

    if (newSearchKey[index] === label) {
      newSearchKey[index] = ''
    } else {
      newSearchKey[index] = label
    }

    handleSearchKeyChange(newSearchKey)
  }

  return (
    <div className={cx('specs', className)}>
      {!(skuItemInfo?.length <= 1) &&
        menu?.map((spec, index) => (
          <div className={cx('specs__wrapper')} key={spec.name}>
            <div className={cx('specs-name', labelClassName, { isFullScreen })}>{spec.name}</div>
            <div className={cx('specs__option-wrapper', { isFullScreen })}>
              {spec.values.map((data) => {
                const isDisable =
                  (searchKeyList[index] === '' && !filteredItemsSpecList.includes(String(data.attrId))) ||
                  data.disabled ||
                  checkDisable(String(data.attrId), index)

                return (
                  <div
                    className={cx('specs-value', {
                      active: String(data.attrId) === searchKeyList[index],
                      disable: isDisable,
                      hide: data.hide,
                    })}
                    key={data.attrId}
                    onClick={() => !isDisable && handleSearch(String(data.attrId), index)}
                  >
                    {/* <Image alt='product-image' src={data.picture} width={40} height={40} style={{ objectFit: 'contain' }} /> */}
                    <div className={cx('specs-value-text')}>{data.value}</div>
                  </div>
                )
              })}
            </div>
          </div>
        ))}
    </div>
  )
}

export default Specs
